module.exports = __webpack_public_path__ + "h5assets/img/pic_3.2b104f5.png";